export function isValidTechSourceObject(source?: any): boolean {
  if (typeof source?.src === 'string') {
    return true;
  }
  return false;
}
